import { render, staticRenderFns } from "./outbound-sms-completed-icon.vue?vue&type=template&id=04bdc317"
import script from "./outbound-sms-completed-icon.vue?vue&type=script&lang=js"
export * from "./outbound-sms-completed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports